import { render, staticRenderFns } from "./ConsultaWrapper.vue?vue&type=template&id=a3188e6c"
import script from "./ConsultaWrapper.vue?vue&type=script&lang=js"
export * from "./ConsultaWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports